module.exports = __webpack_public_path__ + "img/Tessellate25.6da176b2.jpg";